(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-tabs')) {
    // After a value is chosen, move on to the next option's tab.
    // Set to false to keep the current tab open.
    const AUTO_ADVANCE = false;
    const AUTO_ADVANCE_DELAY = 350;

    class VariantTabs extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onChange = this.onChange.bind(this);
        this.sync = this.sync.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('change', this.onChange);
        this.sync();

        // Dawn re-renders the picker after a variant change; keep the open tab.
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['hidden', 'aria-selected'],
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      get key() {
        return this.dataset.sectionId;
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      get panels() {
        return Array.from(this.querySelectorAll('[role="tabpanel"]'));
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.select(Number(tab.dataset.index), false);
      }

      onChange(event) {
        if (!AUTO_ADVANCE) return;

        const panel = event.target.closest('[role="tabpanel"]');
        const panels = this.panels;
        const index = panels.indexOf(panel);
        if (index === -1 || index >= panels.length - 1) return;

        const key = this.key;
        // Stay on this tab while Dawn re-renders the picker...
        VariantTabs.active[key] = index;

        // ...then move to the next one.
        clearTimeout(VariantTabs.timers[key]);
        VariantTabs.timers[key] = setTimeout(() => {
          VariantTabs.active[key] = index + 1;
          document.querySelectorAll('variant-tabs').forEach((el) => {
            if (el.key === key) el.sync();
          });
        }, AUTO_ADVANCE_DELAY);
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        const count = this.tabs.length;
        let index = Number(tab.dataset.index);

        if (event.key === 'ArrowRight') index = (index + 1) % count;
        else if (event.key === 'ArrowLeft') index = (index - 1 + count) % count;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = count - 1;
        else return;

        event.preventDefault();
        this.select(index, true);
      }

      select(index, focus) {
        clearTimeout(VariantTabs.timers[this.key]);
        VariantTabs.active[this.key] = index;
        this.sync();
        if (focus && this.tabs[index]) this.tabs[index].focus();
      }

      sync() {
        const active = VariantTabs.active[this.key] ?? 0;
        const panels = this.panels;

        this.tabs.forEach((tab, i) => {
          const isActive = i === active;
          const panel = panels[i];

          if (tab.getAttribute('aria-selected') !== String(isActive)) {
            tab.setAttribute('aria-selected', String(isActive));
          }
          const tabindex = isActive ? '0' : '-1';
          if (tab.getAttribute('tabindex') !== tabindex) tab.setAttribute('tabindex', tabindex);

          if (panel && panel.hidden === isActive) panel.hidden = !isActive;
        });
      }
    }

    VariantTabs.active = {};
    VariantTabs.timers = {};
    customElements.define('variant-tabs', VariantTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
